import { regex } from '../constants'
import { logOut } from './auth'

export const isEmpty = (value: string) => {
  if (!value) {
    return !value
  }
}

export const isEmptyWithTrim = (value?: string) => !value?.trim()

// Only use forgot-pass and login
export const isEmailOld = (value: string) => regex.RULE.EMAIL_OLD.test(value)

export const isEmail = (value: string) => {
  if (regex.RULE.EMAIL.test(value)) {
    return true
  }

  return false
}

export const isNumber = (value: string) => {
  if (regex.RULE.NUMBER.test(value)) {
    return true
  }

  return false
}

export const isPassword = (value: string) => {
  if (regex.RULE.PASSWORD.test(value)) {
    return true
  }

  return false
}

export const validateRole = (value: string) => {
  if (!value) {
    logOut()
  }
}

export const scrollToFirstValidatorWithMessage = () => {
  requestAnimationFrame(() => {
    const validator = document.querySelector('.components__validator-input')
    if (validator) {
      validator.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  })
}

export const isArrayEmpty = (array?: any[]) => !array || array.length === 0
